export const LIST_TYPE = Object.freeze({
  ordered: 'ol',
  unordered: 'ul'
})
